import { render, staticRenderFns } from "./respuestaPagoPayu.vue?vue&type=template&id=06fc5ef4&"
import script from "./respuestaPagoPayu.vue?vue&type=script&lang=js&"
export * from "./respuestaPagoPayu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports